import store from "@/store";
import PersistenceService from "@/services/PersistenceService";

const namespaced = true;

const state = {
  data: PersistenceService.getFromLocalStorage("user") || null,
};

const mutations = {
  UPDATE(state, user) {
    state.data = user;
    PersistenceService.writeToLocalStorage("user", user);
  },
  DELETE(state) {
    state.data = null;
    PersistenceService.removeFromLocalStorage("user");
  },
};

const actions = {
  update({ commit }, user) {
    commit("UPDATE", user);
  },
  delete({ commit }) {
    commit("DELETE");
  },
  reset({ commit }) {
    commit("DELETE");
  }
};

const getters = {
  getUser: (state) => state.data?.user,
  getUserPermissions: (state) => state.data?.permissions ?? {},
  isLoggedIn: (state) => !_.isNil(state.data?.user),
  isAuthorized: (state) => (ifce) => {
    if (state.data && state.data.permissions) {
      if(state.data.permissions.instanceOwner) return true;
      const t = store.getters["tenants/currentTenantId"];
      const adIfces = state.data.permissions.tenants?.find((p) => p.tenantId === t);
      if(!adIfces) return false;

      // allow tenant admins to access user groups and bulk import
      if (
        (ifce === "user-groups" || ifce === "Massenimport") &&
        adIfces.isOwner
      ) {
        return true;
      }

      return adIfces.adminInterfaces.includes(ifce);
    }
    return false;
  },
  isInstanceOwner: (state) => !!state.data.permissions.instanceOwner,
  isTenantOwner: (state) => {
    const t = store.getters["tenants/currentTenantId"];
    const tenantPermission = state.data.permissions.tenants?.find(
      (p) => p.tenantId === t
    );
    return tenantPermission?.isOwner === true;
  },
  hasAdminAccess: (state) => {
    const permissions = state.data?.permissions;
    if (!permissions) return false;

    const { instanceOwner, tenants = [] } = permissions;

    const isTenantOwnerOrAdmin = tenants.some((tenant) => {
      if (tenant.isOwner) return true;

      const managementKeys = [
        "manageUsers",
        "manageRoles",
        "manageBookables",
        "manageBookings",
        "manageCoupons",
      ];

      const hasAdminInterface = tenant.adminInterfaces?.length > 0;
      const hasManagementPermission = managementKeys.some(
        (key) => Object.keys(tenant[key] || {}).length > 0
      );

      return hasAdminInterface || hasManagementPermission;
    });

    return instanceOwner || isTenantOwnerOrAdmin;
  },
  allowToCreateTenants: (state) => {
    if (state.data && state.data.permissions) {
      return state.data.permissions.allowCreateTenant;
    }
    return false;
  }
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced,
};
